import "./OpeningHours.css";

const OpeningHours = () => (
  <div
    className="app__openingHours-wrapper app__openingHours-bg"
  >
    <div className="app__openingHours-data">
      <h1>ÖFFNUNGSZEITEN</h1>
      <h2>Montag - Sonntag</h2>
      <h2>9:30 - 21:30</h2>
    </div>
  </div>
);

export default OpeningHours;
